import qrcode from "qrcode-generator";
import { useMemo, useState } from "react";
import { Alert, Button } from "../../ds";

// Die fertige Client-Konfiguration — einmalig, direkt nach dem Anlegen.
//
// Sie enthält den privaten Schlüssel des Clients. Der ist im Browser entstanden
// und liegt NIRGENDWO sonst: nicht in der Datenbank, nicht in einem Log, nicht
// auf dem Server. Wer diesen Dialog schließt, ohne zu sichern, braucht einen
// neuen Zugang — das ist der Preis dafür, dass ihn uns niemand abnehmen kann.

/** Fehlerkorrektur M: die Konfiguration ist kurz genug, und M übersteht ein
 *  Handydisplay-Foto zuverlässiger als L. */
const ECC = "M";

export function WgClientConfig({ name, config }: { name: string; config: string }) {
  const [kopiert, setKopiert] = useState(false);

  const qr = useMemo(() => {
    try {
      // Typ 0 = automatisch die kleinste Version, die passt.
      const code = qrcode(0, ECC);
      code.addData(config);
      code.make();
      return code.createDataURL(4, 2);
    } catch {
      // Zu lang für einen QR-Code (viele Standortnetze in AllowedIPs). Kein
      // Grund, den ganzen Dialog scheitern zu lassen — Text und Datei tun es
      // auch, der QR ist die Bequemlichkeit.
      return null;
    }
  }, [config]);

  const datei = `${name.replace(/[^A-Za-z0-9_-]+/g, "-").replace(/^-|-$/g, "") || "eulektro"}.conf`;

  return (
    <div className="flex flex-col gap-4">
      <Alert variant="warning">
        Der private Schlüssel steht <strong>nur hier</strong>. Er wurde in diesem Browser erzeugt
        und nie an den Server geschickt — Spyship kann ihn nicht noch einmal zeigen. Jetzt scannen
        oder herunterladen; danach ist er weg.
      </Alert>

      <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
        {qr && (
          <div className="shrink-0 self-center rounded-lg bg-white p-3 sm:self-start">
            {/* Auf weißem Grund, unabhängig vom Thema: ein QR-Code auf dunklem
                Hintergrund ist invertiert und wird von vielen Scannern nicht
                gelesen. */}
            <img src={qr} alt={`WireGuard-Konfiguration für ${name}`} width={180} height={180} />
          </div>
        )}
        <pre className="bg-surface-2 font-mono min-w-0 flex-1 overflow-x-auto rounded-lg p-3 text-xs leading-relaxed text-content">
          {config}
        </pre>
      </div>

      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          iconName={kopiert ? "check" : "doc"}
          onClick={() =>
            void navigator.clipboard.writeText(config).then(
              () => setKopiert(true),
              () => setKopiert(false),
            )
          }
        >
          {kopiert ? "kopiert" : "Konfiguration kopieren"}
        </Button>
        <a
          className="ds-btn ds-btn-outline"
          download={datei}
          href={`data:application/octet-stream;charset=utf-8,${encodeURIComponent(config)}`}
        >
          {datei} herunterladen
        </a>
      </div>
    </div>
  );
}
